import type { FormSchemaType } from '@/schema';
import { PaiementStep } from '@workspace/core-ts/components';
import { paiementStepContent } from '@workspace/core-ts/content';
import { useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { useSource } from '@workspace/core-ts/hooks';
import { normalizeEuro } from '@workspace/utils';

export default function PaiementLivraison() {
  const methods = useSmartFormGlobal<FormSchemaType>();
  const { isCourtier } = useSource();

  const MontantComptant = methods.watch('Devis.Formule.MontantComptant');
  const FractionnementChoisi = methods.watch('DemandeTarif.Police.FractionnementChoisi');
  const MontantComReglement = methods.watch('Devis.Formule.MontantCommApporteurReglette');
  const MontantTauxCommission = methods.watch('DemandeTarif.Police.TauxApporteur1');
  const MontantHonoraires = methods.watch('DemandeTarif.Police.Honoraires');
  const totalPrimeMensuelle = methods.watch('Devis.Formule.PrimeMensuelle');
  const totalPrimeAnnuelle = methods.watch('Devis.Formule.PrimeAnnuelleFracAnnuel');
  const totalAttentat = methods.watch('Devis.Formule.MontantTaxeAttentat');

  const prochainPrelevement = FractionnementChoisi === 'M' ? totalPrimeMensuelle : totalPrimeAnnuelle;

  return (
    <PaiementStep
      embedded
      content={{
        ...paiementStepContent,
        assuranceNote: {
          site: `Vos véhicules seront intégrés sous 72h au FVA (Fichier des Véhicules Assurés).<br/><br/>Le prochain prélèvement sera de <strong>${normalizeEuro(prochainPrelevement)} TTC</strong>.`,
          conseiller: `Vos véhicules seront intégrés sous 72h au FVA (Fichier des Véhicules Assurés).<br/><br/>Le prochain prélèvement sera de <strong>${normalizeEuro(prochainPrelevement)} TTC</strong>.`,
          courtier: `Votre taux de commission est de <strong>${MontantTauxCommission}%</strong> soit <strong>${normalizeEuro(MontantComReglement)}</strong>.<br/>Vous avez <strong>${normalizeEuro(MontantHonoraires)}</strong> de frais de dossier.<br/><br/>Les véhicules seront intégrés sous 72h au FVA (Fichier des Véhicules Assurés).<br/><br/>Le prochain prélèvement sera de <strong>${normalizeEuro(prochainPrelevement)} TTC</strong>.`,
        },
      }}
      customTarifs={{
        premierPaiement: MontantComptant ?? 0,
        formuleChoisie: '',
        fractionnement: FractionnementChoisi ?? 'M',
        taxeAttentat: totalAttentat ?? 0,
      }}
      firstPaymentLabel={() => {
        const correspondance = FractionnementChoisi === 'M' ? 'aux deux premières mensualités' : 'à votre première année';
        const fraisDossier = isCourtier ? ' et aux frais de dossier' : '';

        return `${isCourtier ? 'Votre client va payer' : 'Paiement de'} <strong>${normalizeEuro(MontantComptant ?? 0)} TTC</strong> correspondant ${correspondance}${fraisDossier}`;
      }}
    />
  );
}
